import React from "react";

export const Estilos = ({ listas, filtrar }) => {
  return (
    <div className="c-modal-1__section">
      <div className="c-modal-1__heading">Estilo</div>
      <div className="c-modal-1__item">
        <div className="c-list-6">
          {listas.listasestilos.map((item) => (
            <div className="c-list-6__item" key={item.id}>
              <div className="o-form-check">
                <input
                  className="o-form-check__campo--v2"
                  id={`check-estilo-${item.id}`}
                  type="checkbox"
                  name="marca__check"
                  value={item.id}
                  onClick={filtrar}
                />
                <label htmlFor={`check-estilo-${item.id}`}>
                  <span className="c-form-1__text-2">
                    {" "}
                    {item.nombre_estilo}{" "}
                  </span>
                </label>
                <input type="hidden" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
